import React from 'react';
import {} from 'prop-types';
import cx from 'classnames';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';

import { PageSection } from '../';

const CLASS_ROOT = 'map';

const propTypes = {};

const MapView = ({ className, children, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  const floatingBox = children && <div className="map__box">{children}</div>;

  const MapWrapper = typeof window !== 'undefined' && (
    <Map
      center={[48.160056, 17.144831]}
      zoom={17}
      style={{ height: '500px' }}
      animate
      scrollWheelZoom={false}
      tap={false}
      className="map__wrapper"
    >
      {/* eslint-disable-next-line */}
      <TileLayer url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png" />
      {/* https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png */}
      <Marker position={[48.159863, 17.141816]}>
        <Popup>
          Bajkalská 12/b <br />
          Bratislava
        </Popup>
      </Marker>
    </Map>
  );

  return (
    <div className={classes} {...other}>
      <PageSection space="none">
        {floatingBox}
        {MapWrapper}
      </PageSection>
    </div>
  );
};

MapView.propTypes = propTypes;

export default MapView;
